import SelectActivities from './SelectActivities';
import './SelectActivities.css';
export default SelectActivities;
